import React from 'react';

import { CommonInputProps } from './FormInputInternals';
import { FormNumberInput } from './FormNumberInput';

interface FormMoneyInputProps extends CommonInputProps {
    placeholder?: string;
    optional?: boolean;
    decimalScale?: number;
    allowNegative?: boolean;
}
export const FormMoneyInput = ({ allowNegative = false, ...props }: FormMoneyInputProps) => {
    return (
        <FormNumberInput
            placeholder="$$$"
            {...props}
            thousandSeparator
            prefix="$"
            valueIsNumericString
            allowNegative={allowNegative}
        />
    );
};
